export const UPDATE_INVOICE_NUMBER = `
    mutation updateInvoiceNumber($invoiceNumber: Int!) {
        invoiceNumber(invoiceNumber: $invoiceNumber) {
            invoiceNumber
        }
    }
`

export const UPDATE_TOTAL_BILLED = `
    mutation updateTotalBilled($mutateParams: ClientMutationInput!) {
        client(mutateParams: $mutateParams) {
            totalBilled
        }
    }
`

export const UPDATE_CALENDAR = `
    mutation updateCalendar($mutateParams: CounsellorMutationInput!, $requestParams: DateParams!) {
        counsellor(mutateParams: $mutateParams, requestParams: $requestParams) {
            acuityID
            fee
            share
            external
            name
            GSTEnabled
            appointments {
                GST
                sessionLocation
                amountPaid
                calendar
                counsellorID
                date
                email
                firstName
                lastName
                id
                paid
                phone
                price
                time
                type
                paymentSource
                clientRate
                counsellorRate
            }
        }
    }
`

export const UPDATE_CLIENT_INFO = `
    mutation updateClientInfo($mutateParams:  ClientAdminsMutation!) {
        clientAdminsRole(mutateParams: $mutateParams) {
            approvedSessions
            expiryDate
            email
            firstName
            id
            isActive
            lastName
            mutationRequest
            notes
            paymentSource
            phone
            totalBilled
        }
    }
`

export const UPDATE_EMAIL_TEXT = `
    mutation updateEmailText($text: String!) {
        emailText(text: $text) {
            text
        }
    }
`

export const UPDTATE_COUNSELLOR_PHONE = `
    mutation updateCounsellorPhone($mutateParams: CounsellorBaseMutationInput!) {
        counsellorBaseRole(mutateParams: $mutateParams, requestParams: {}) {
            phone
        }
    }
`

export const UPDATE_BAD_FIT_ITEM = `
    mutation updateBadFitItem($badFitId: Int!, $params:  BadFitMutateParams!) {
        badFit(badFitId: $badFitId, params: $params) {
            id
            isGrey
            isGoodFeet
            notes
            dateCreated
            client {
                lastName
                firstName
            }
            counsellor {
                name
            }
        }
    }
`